export const customerRouter = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/customer/Home.vue'),
    meta: {
      name: '首页',
      index: 1,
      keepAlive: true,
      showNav: true,
      pageCode: 'sm_app_home_page'
    }
  },
  {
    path: '/choiceness',
    name: 'choiceness',
    component: () => import('../views/customer/choiceness/Detail.vue'),
    meta: {
      name: '精选配置',
      index: 2,
      keepAlive: true,
      showNav: false,
      pageCode: 'sm_choiceness_page'
    }
  },
  {
    path: '/paymentSuccess',
    name: 'paymentSuccess',
    component: () => import('../views/customer/payment/PaymentSuccess.vue'),
    meta: {
      name: '支付成功',
      index: 5,
      keepAlive: true,
      showNav: false,
      pageCode: 'sm_payment_success_page'
    }
  },
  {
    path: '/paymentFailure',
    name: 'paymentFailure',
    component: () => import('../views/customer/payment/PaymentFailure.vue'),
    meta: {
      name: '支付失败',
      index: 5,
      keepAlive: true,
      showNav: false,
      pageCode: 'sm_payment_failure_page'
    }
  },
  {
    path: '/bo_user_bind',
    name: 'bindUser',
    component: () => import('../views/customer/BindUser.vue'),
    meta: {
      name: '绑定账号',
      index: 5,
      keepAlive: true,
      showNav: false,
      pageCode: 'sm_user_bind_page'
    }
  },
  {
    path: '/planList',
    name: 'planList',
    component: () => import('../views/customer/plan/PlanList.vue'),
    meta: {
      name: '计划列表',
      index: 2,
      keepAlive: true,
      showNav: true,
      pageCode: 'sm_loyalty_list_page'
    }
  },
  {
    path: '/tyreList',
    name: 'tyreList',
    component: () => import('../views/customer/tyre/TyreList.vue'),
    meta: {
      name: '轮胎列表',
      index: 2,
      keepAlive: true,
      showNav: false,
      pageCode: 'sm_tyre_list_page'
    }
  },
  {
    path: '/tyreDetail',
    name: 'tyreDetail',
    component: () => import('../views/customer/tyre/TyreDetail.vue'),
    meta: {
      name: '轮胎详情',
      index: 3,
      keepAlive: false,
      showNav: false,
      noBFC: true,
      pageCode: 'sm_tyre_detail_page'
    }
  },
  {
    path: '/exclusive',
    name: 'exclusive',
    component: () => import('../views/customer/tyre/Exclusive.vue'),
    meta: {
      name: '',
      index: 2,
      keepAlive: false,
      showNav: false,
      noBFC: true
    }
  },
  {
    path: '/createOrder',
    name: 'createOrder', //下单
    component: () => import('../views/customer/tyre/CreateOrder.vue'),
    meta: {
      name: '创建订单（轮胎）',
      index: 4,
      keepAlive: false,
      showNav: false,
      noBFC: false,
      pageCode: 'sm_tyre_create_order_page'
    }
  },
  {
    path: '/orderOver',
    name: 'orderOver',
    component: () => import('../components/tyre/OrderOver.vue'),
    meta: {
      name: '到店下单二维码',
      index: 5,
      keepAlive: false,
      showNav: false,
      noBFC: false,
      pageCode: 'sm_order_over_page'
    }
  },
  {
    path: '/compensationRecord',
    name: 'compensationRecord', //补偿条款
    component: () => import('../views/customer/tyre/CompensationRecord.vue'),
    meta: {
      name: '补偿条款',
      index: 3,
      keepAlive: false,
      showNav: false,
      noBFC: true
    }
  },
  {
    path: '/tyreExclusiveOrder',
    name: 'tyreExclusiveOrder',
    component: () => import('../views/customer/tyre/TyreExclusiveOrder.vue'),
    meta: {
      name: '',
      index: 4,
      keepAlive: false,
      showNav: false,
      noBFC: true
    }
  },
  {
    path: '/addTyreImg',
    name: 'addTyreImg',
    component: () => import('../views/customer/tyre/AddTyreImg.vue'),
    meta: {
      name: '上传图片',
      index: 5,
      keepAlive: false,
      showNav: false,
      noBFC: true,
      pageCode: 'sm_tyre_add_img_page'
    }
  },
  {
    path: '/planDetail',
    name: 'planDetail',
    component: () => import('../views/customer/plan/PlanDetail.vue'),
    meta: {
      name: '计划详情',
      index: 3,
      keepAlive: false,
      showNav: false,
      pageCode: 'sm_loyalty_detail_page'
    }
  },
  {
    path: '/mine',
    name: 'mine',
    component: () => import('../views/customer/Mine.vue'),
    meta: {
      name: '个人中心',
      index: 1,
      keepAlive: false,
      showNav: true,
      pageCode: 'sm_personal_center_page'
    }
  },
  {
    path: '/orderList',
    name: 'OrderList',
    component: () => import('../views/customer/order/OrderList.vue'),
    meta: {
      name: '订单列表',
      index: 2,
      keepAlive: false,
      showNav: false,
      pageCode: 'sm_order_list_page'
    }
  },
  {
    path: '/orderDetail',
    name: 'OrderDetail',
    component: () => import('../views/customer/order/OrderDetail.vue'),
    meta: {
      name: '订单详情',
      index: 3,
      keepAlive: false,
      showNav: false,
      pageCode: 'sm_order_detail_page'
    }
  },
  {
    path: '/carList',
    name: 'carList',
    component: () => import('../views/customer/car/CarList.vue'),
    meta: {
      name: '车辆列表',
      index: 2,
      keepAlive: false,
      showNav: false,
      pageCode: 'sm_car_list_page'
    }
  },
  {
    path: '/editCarInfo',
    name: 'editCarInfo',
    component: () => import('../views/customer/car/EditCarInfo.vue'),
    meta: {
      name: '编辑车辆信息',
      index: 3,
      keepAlive: false,
      showNav: false,
      pageCode: 'sm_car_edit_page'
    }
  },
  {
    path: '/shoppingCar',
    name: 'shoppingCar',
    component: () => import('../views/customer/ShoppingCar.vue'),
    meta: {
      name: '购物车',
      index: 1,
      keepAlive: false,
      showNav: true,
      pageCode: 'sm_shopping_cart_page'
    }
  },
  {
    path: '/confirmOrder',
    name: 'confirmOrder',
    component: () => import('../views/customer/order/ConfirmOrder.vue'),
    meta: {
      name: '创建订单（计划）',
      index: 6,
      keepAlive: false,
      showNav: false,
      pageCode: 'sm_loyalty_create_order_page'
    }
  },
  {
    path: '/myLoyaltyPlanList',
    name: 'myLoyaltyPlanList',
    component: () => import('../views/customer/plan/MyLoyaltyPlanList.vue'),
    meta: {
      name: '我的致友计划列表',
      index: 2,
      keepAlive: false,
      showNav: false,
      pageCode: 'sm_myloyalty_list_page'
    }
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('../views/customer/Search.vue'),
    meta: {
      name: '搜索',
      index: 2,
      keepAlive: true,
      showNav: true,
      pageCode: 'sm_search_common_page'
    }
  },
  {
    path: '/consumptionDetail',
    name: 'consumptionDetail',
    component: () => import('../views/customer/plan/ConsumptionDetail.vue'),
    meta: {
      name: '消费明细',
      index: 6,
      keepAlive: false,
      showNav: false,
      pageCode: 'sm_consumption_detail_page'
    }
  },
  {
    path: '/couponCollection',
    name: 'couponCollection',
    component: () => import('../views/customer/coupon/CouponCollection.vue'),
    meta: {
      name: '优惠券列表',
      index: 2,
      keepAlive: false,
      showNav: true,
      pageCode: 'sm_coupon_list_page'
    }
  },
  {
    path: '/couponDetail',
    name: 'couponDetail',
    component: () => import('../views/customer/coupon/CouponDetail.vue'),
    meta: {
      name: '优惠券详情',
      index: 3,
      keepAlive: false,
      showNav: false,
      pageCode: 'sm_coupon_detail_page'
    }
  },
  {
    path: '/myCouponList',
    name: 'myCouponList',
    component: () => import('../views/customer/coupon/MyCouponList.vue'),
    meta: {
      name: '我的优惠券列表',
      index: 4,
      keepAlive: false,
      showNav: true,
      pageCode: 'sm_mycoupon_list_page'
    }
  },
  {
    path: '/myCouponDetail',
    name: 'myCouponDetail',
    component: () => import('../views/customer/coupon/MyCouponDetail.vue'),
    meta: {
      name: '我的优惠券详情',
      index: 6,
      keepAlive: false,
      showNav: true,
      pageCode: 'sm_mycoupon_detail_page'
    }
  },
  {
    // oab预约创建
    path: '/oabCreate',
    name: 'oabCreate',
    component: () => import('../views/customer/oab/create.vue'),
    meta: {
      name: 'oab预约创建',
      index: 2,
      keepAlive: false,
      showNav: false,
      pageCode: 'sm_oab_create_page'
    }
  },
  {
    // oab预约列表
    path: '/oabList',
    name: 'oabList',
    component: () => import('../views/customer/oab/list.vue'),
    meta: {
      name: 'oab预约列表',
      index: 2,
      keepAlive: false,
      showNav: false,
      pageCode: 'sm_oab_list_page'
    }
  },
  {
    // oab预约详情
    path: '/oabDetail',
    name: 'oabDetail',
    component: () => import('../views/customer/oab/detail.vue'),
    meta: {
      name: 'oab预约详情',
      index: 3,
      keepAlive: false,
      showNav: false,
      pageCode: 'sm_oab_detail_page'
    }
  },
  {
    path: '/SystemMaintenance',
    name: 'systemMaintenance',
    component: () => import('../views/customer/system/SystemMaintenance.vue'),
    meta: {
      name: '系统维护',
      index: 1,
      keepAlive: false,
      showNav: false,
      pageCode: 'sm_system_maintenance_page'
    }
  },
  // 完善信息
  {
    path: '/completeInfo',
    name: 'completeInfo',
    component: () => import('../views/customer/CompleteInfo.vue'),
    meta: {
      name: '完善信息',
      index: 2,
      keepAlive: true,
      showNav: false,
      pageCode: 'sm_complete_info_page'
    }
  },
  // 地址列表
  {
    path: '/addressList',
    name: 'addressList',
    component: () => import('../views/customer/address/AddressList.vue'),
    meta: {
      name: '地址列表',
      index: 3,
      keepAlive: true,
      showNav: false,
      pageCode: 'sm_address_list_page'
    }
  },
  // 编辑地址
  {
    path: '/addressEdit',
    name: 'addressEdit',
    component: () => import('../views/customer/address/AddressEdit.vue'),
    meta: {
      name: '编辑地址',
      index: 4,
      keepAlive: true,
      showNav: false,
      pageCode: 'sm_address_edit_page'
    }
  },
  {
    path: '/contactsList',
    name: 'contactsList',
    component: () => import('../views/customer/directSales/ContactsList.vue'),
    meta: {
      name: '联系人列表',
      index: 2,
      keepAlive: false,
      showNav: false,
      pageCode: 'sm_contacts_list_page'
    }
  },
  {
    path: '/shop',
    name: 'shop',
    component: () => import('../views/customer/Shop.vue'),
    meta: {
      name: '商品列表',
      index: 1,
      keepAlive: true,
      showNav: true,
      noBFC: true,
      pageCode: 'sm_product_list_page'
    }
  },
  {
    path: '/shopDetail',
    name: 'shopDetail',
    component: () => import('../views/customer/directSales/ShopDetail.vue'),
    meta: {
      name: '商品详情',
      index: 3,
      keepAlive: false,
      showNav: false,
      noBFC: true,
      pageCode: 'sm_product_detail_page'
    }
  },
  {
    path: '/shopPreView',
    name: 'shopPreView',
    component: () => import('../views/customer/directSales/ViewDetail.vue'),
    meta: {
      name: '商品详情预览',
      index: 3,
      keepAlive: false,
      showNav: false,
      noBFC: true,
      pageCode: 'sm_product_preview_page'
    }
  },
  {
    path: '/ewShopDetail',
    name: 'ewShopDetail',
    component: () => import('../views/customer/directSales/EWShopDetail.vue'),
    meta: {
      name: '延保商品详情',
      index: 3,
      keepAlive: false,
      showNav: false,
      noBFC: true,
      pageCode: 'sm_ew_product_detail_page'
    }
  },
  {
    path: '/ew/shopPreView',
    name: 'ewShopPreView',
    component: () => import('../views/customer/directSales/EWViewDetail.vue'),
    meta: {
      name: '延保商品详情预览',
      index: 3,
      keepAlive: false,
      showNav: false,
      noBFC: true,
      pageCode: 'sm_ew_product_preview_page'
    }
  },
  {
    path: '/confirmDirectSalesOrder',
    name: 'confirmDirectSalesOrder',
    component: () => import('../views/customer/directSales/ConfirmOrder.vue'),
    meta: {
      name: '创建订单（商城）',
      index: 6,
      keepAlive: false,
      showNav: false,
      pageCode: 'sm_product_create_order_page'
    }
  },
  {
    path: '/:pathMatch(.*)*', // 需要使用正则去匹配
    redirect: () => import('../views/customer/Home.vue')
  }
]
